
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return require("private-next-pages/account/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account"])
      });
    }
  